import { Button, UnstyledButton, type ButtonProps, type UnstyledButtonProps } from '@mantine/core';
import { createLink, type LinkComponent } from '@tanstack/react-router';
import { forwardRef, type ReactNode } from 'react';

// TanStack's documented pattern for Mantine: pin the polymorphic component to an anchor first,
// so createLink sees a plain forwardRef component and keeps the router's route/param typing.

const AnchorButton = forwardRef<HTMLAnchorElement, ButtonProps & { children?: ReactNode }>((props, ref) => (
  <Button ref={ref} component="a" {...props} />
));
AnchorButton.displayName = 'AnchorButton';
const CreatedButtonLink = createLink(AnchorButton);
/** Route-typed link rendered as a Mantine Button. */
export const ButtonLink: LinkComponent<typeof AnchorButton> = (props) => <CreatedButtonLink preload="intent" {...props} />;

const AnchorUnstyled = forwardRef<HTMLAnchorElement, UnstyledButtonProps & { children?: ReactNode }>((props, ref) => (
  <UnstyledButton ref={ref} component="a" {...props} />
));
AnchorUnstyled.displayName = 'AnchorUnstyled';
const CreatedUnstyledLink = createLink(AnchorUnstyled);
/** Route-typed link rendered as a Mantine UnstyledButton (whole-card links). */
export const UnstyledButtonLink: LinkComponent<typeof AnchorUnstyled> = (props) => <CreatedUnstyledLink preload="intent" {...props} />;
